import React from "react";
import DownloadBrochure from "./DownloadBrochure";
import hero from "../assets/img/Industries/biotech_hero.jpg";
import doc_sub_1 from "../assets/img/Industries/biotech_sub_1.jpg";
import doc_sub_2 from "../assets/img/Industries/biotech_sub_2.jpg";
import { Link as RouterLink } from 'react-router-dom';


const BioTechIndustry = () => {

    return (
        <div className='portifoliobody'>
                <main id="main">
                    <section id="pharma" className="about text-start" style={{paddingTop:'40px'}}>
                        <div className="ph-hero">
                            <div className="ph-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                                <div className="ph-title-content">
                                    <h1>Integrated and Scalable Biotech Solutions for Advanced Research and Innovation</h1>
                                    <p>Enhance Efficiency, Safeguard Data Integrity, and Foster Collaboration with Our Advanced Cloud-Based Platform.</p>
                                </div>
                                <div className="book_a_demo">
                                    <RouterLink to='/demo'> 
                                        <button className="book_a_demo_btn">Get a Demo</button>
                                    </RouterLink>
                                </div>
                            </div>
                            <div className="bio-hero-img">
                                <div className="ph-hero-img carousel-container animate__animated animate__fadeInRight" data-aos="fade-right" data-aos-delay="100">
                                    <img src={hero} alt="pharma lab" />
                                </div>
                            </div>
                        </div>

                        <div className="section-container" style={{marginTop:'0'}}>
                            <div className="row">
                                <div className="section-pro">
                                    <div className="sec-out">
                                        <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                            <img src={doc_sub_1} alt="pharma lab"/>
                                        </div>  
                                        <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                            <div className="sec-title"><h1>Optimizing Biotech Research & Innovation </h1></div>
                                            <ul>
                                                <li><b>Accelerated Discovery & Development  – </b>Streamline workflows for drug discovery, genetic research, and biotechnology innovations with an integrated platform.</li>
                                                <li><b>Regulatory Compliance & Data Integrity  – </b> Ensure adherence to <b>FDA, GxP, ISO, and HIPAA</b> with secure audit trails, electronic signatures, and access controls.</li>
                                                <li><b>Advanced Data Management & Analytics  – </b>Leverage AI-driven insights, automated data capture, and real-time reporting for informed decision-making.</li>
                                                <li><b>Seamless ELN & LIMS Integration  – </b> Connect effortlessly with ELN, LIMS, and laboratory instruments to centralize data and improve research efficiency.</li>
                                                <li><b>Cloud-Enabled Scalability  – </b>Support multi-site operations and remote research teams with a secure, cloud-based infrastructure for global collaboration. </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="sec-out" style={{paddingTop:'2rem'}}>
                                        <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                            <img src={doc_sub_2} alt="pharma lab"/>
                                        </div>  
                                        <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                            <div className="sec-title"><h1>Enhancing Biotech Manufacturing & Compliance</h1></div>
                                            <ul>
                                                <li><b>Optimized Production Workflows  – </b>Automate biotech manufacturing processes, from cell culture tracking to bioprocess optimization, ensuring consistency and quality.</li>
                                                <li><b>Supply Chain & Inventory Management – </b> Track raw materials, reagents, and consumables in real-time to prevent shortages and maintain production continuity.</li>
                                                <li><b>Quality Control & Assurance – </b> Monitor and enforce strict QC protocols with automated sample testing, stability studies, and deviation tracking.</li>
                                                <li><b>Instrument & System Connectivity – </b> Integrate with <b> MES, ERP, QMS, and lab automation systems</b> for seamless data flow and process standardization.</li>
                                                <li><b>Robust Security & IP Protection – </b> Safeguard biotech innovations with end-to-end encryption, role-based access, and compliance-driven security protocols.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </main>
            <div data-aos="fade-up" data-aos-delay="100">
                <DownloadBrochure product={'Industries'}/>
            </div>
                
        </div>
    )
}

export default BioTechIndustry;